document.addEventListener("DOMContentLoaded", () => {
  const initCarousel = () => {
    const sections = document.querySelectorAll(".featured-collections-section");
    if (!sections.length) return;

    sections.forEach((sectionElement) => {
      const emblaNode = sectionElement.querySelector(".embla");
      if (!emblaNode) return;

      const viewportNode = emblaNode.querySelector(".embla__viewport");
      const dotsNode = sectionElement.querySelector(".embla__dots");

      let embla = sectionElement.emblaInstance;

      if (window.innerWidth < 770) {
        if (!embla) {
          const options = {
            duration: 15,
            align: "start",
            containScroll: "trimSnaps",
            dragFree: false
          };

          embla = EmblaCarousel(viewportNode, options);
          sectionElement.emblaInstance = embla;

          let dotsArray = [];
          let selectedDotIndex = 0;

          const generateDots = () => {
            if (!dotsNode) return;
            const scrollSnaps = embla.scrollSnapList();
            const dotsHTML = scrollSnaps.reduce((acc, _, index) => {
              return acc + `<button class="embla__dot" type="button" aria-label="Go to slide ${index + 1}"></button>`;
            }, "");
            dotsNode.innerHTML = dotsHTML;
            dotsArray = Array.from(dotsNode.querySelectorAll(".embla__dot"));

            dotsArray.forEach((dot, index) => {
              dot.addEventListener("click", () => {
                embla.scrollTo(index);
              });
            });
          };

          const updateDots = () => {
            if (!dotsArray || dotsArray.length === 0) return;
            const previousDotIndex = selectedDotIndex;
            selectedDotIndex = embla.selectedScrollSnap();
            if (dotsArray[previousDotIndex]) {
              dotsArray[previousDotIndex].classList.remove("embla__dot--selected");
            }
            if (dotsArray[selectedDotIndex]) {
              dotsArray[selectedDotIndex].classList.add("embla__dot--selected");
            }
          };

          generateDots();
          updateDots();

          embla.on("select", updateDots);
          embla.on("resize", () => {
            generateDots();
            updateDots();
          });
        }
      } else {
        if (embla) {
          embla.destroy();
          sectionElement.emblaInstance = null;
          if (dotsNode) {
            dotsNode.innerHTML = "";
          }
        }
      }
    });
  };

  initCarousel();

  let resizeTimeout;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(initCarousel, 150);
  });
});
